import axios from 'axios';
import * as Constants from "../common/constants";
import * as HelperFunctions from '../common/functions/helperFunctions';
import { FileModel } from "../models/fileModel";
import { RawDataFilterSettingsModel } from "../models/dataSynchronization";
import { ImportSyncDataFilterSettingsModel } from "../models/dataSynchronization";
import { ImportAdminMedicineModel } from "../models/dataSynchronization";
import { SyncSettingsModel } from "../models/dataSynchronization";
import { SchedulerFilterSettingsModel } from "../models/dataSynchronization";
import { EmaDataRowModel } from "../models/dataSynchronization";
import AuthService from './authService';
class DataSyncService {
  authService = new AuthService();

  constructor() {
    axios.defaults.baseURL = `${Constants.apiUrl}/`;
    axios.defaults.headers = {
      "Content-Type": "application/json; charset=utf-8",
      Authorization: `Bearer ${this.authService.getToken()}`,
      Pragma: 'no-cache'
    }
  }

  //LoadData controller actions
  loadDataFromFile(file: FileModel) {
    return axios({
      url: `loadData/loadDataFile/`,
      method: 'post',
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      },
      data: JSON.stringify(file)
    })
      .then(res => res.data.data)
      .catch(error =>
        Promise.reject(HelperFunctions.getErrorMessage(error))
      )
  }

  getAllLoaded(from: number, numberOfRows: number, settings: RawDataFilterSettingsModel) {
    return axios({
      url: `loadData/getAll/${from}/${numberOfRows}`,
      method: 'post', headers: {
        "Content-Type": "application/json; charset=utf-8"
      },
      data: JSON.stringify(settings)
    })
      .then(res => res.data.data)
      .catch(error =>
        Promise.reject(HelperFunctions.getErrorMessage(error))
      )
  }

  getDataSourceRow(id: number) {
    return axios({
      url: `loadData/getDataSourceRow/${id}`,
      method: 'get'
    })
      .then(res => res.data.data)
      .catch(error =>
        Promise.reject(HelperFunctions.getErrorMessage(error))
      )
  }

  getDataSourceFull(id: number) {
    return axios({
      url: `loadData/getDataSourceFull/${id}`,
      method: 'get'
    })
      .then(res => res.data.data)
      .catch(error =>
        Promise.reject(HelperFunctions.getErrorMessage(error))
      )
  }

  loadSingleRowFromPath(rowNum: number, filePath: string) {
    return axios({
      url: `loadData/loadSingleRow/${rowNum}`,
      method: 'post', headers: {
        "Content-Type": "application/json; charset=utf-8"
      },
      data: JSON.stringify(filePath)
    })
      .then(res => res.data.data)
      .catch(error =>
        Promise.reject(HelperFunctions.getErrorMessage(error))
      )
  }

  deleteDataSourceRow(id: number) {
    return axios({
      url: `loadData/deleteDataSource/${id}`,
      method: 'delete'
    })
      .then(res => res.data.data)
      .catch(error =>
        Promise.reject(HelperFunctions.getErrorMessage(error))
      )
  }

  deleteAllImportedData(id: number) {
    return axios({
      url: `loadData/deleteAllImported/${id}`,
      method: 'delete'
    })
      .then(res => res.data.data)
      .catch(error =>
        Promise.reject(HelperFunctions.getErrorMessage(error))
      )
  }

  ///ImportData And SyncData controller actions

  getAllImported(from: number, numberOfRows: number, settings: ImportSyncDataFilterSettingsModel) {
    return axios({
      url: `importData/getAll/${from}/${numberOfRows}`,
      method: 'post', headers: {
        "Content-Type": "application/json; charset=utf-8"
      },
      data: JSON.stringify(settings)
    })
      .then(res => res.data.data)
      .catch(error =>
        Promise.reject(HelperFunctions.getErrorMessage(error))
      )
  }

  getImported(id: number) {
    return axios({
      url: `importData/getImported/${id}`,
      method: 'get'
    })
      .then(res => res.data.data)
      .catch(error =>
        Promise.reject(HelperFunctions.getErrorMessage(error))
      )
  }

  importSingleMedicine(rawData: EmaDataRowModel) {
    return axios({
      url: `ImportData/importSingle/`,
      method: 'post',
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      },
      data: JSON.stringify(rawData)
    })
      .then(res => res.data.data)
      .catch(error =>
        Promise.reject(HelperFunctions.getErrorMessage(error))
      )
  }

  importSingleMedicinePlainText(rawData: EmaDataRowModel) {
    return axios({
      url: `ImportData/importSinglePlainText/`,
      method: 'post',
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      },
      data: JSON.stringify(rawData)
    })
      .then(res => res.data.data)
      .catch(error =>
        Promise.reject(HelperFunctions.getErrorMessage(error))
      )
  }

  getImportedAndSyncData(id: number) {
    return axios({
      url: `importData/getImportAndSyncData/${id}`,
      method: 'get'
    })
      .then(res => res.data.data)
      .catch(error =>
        Promise.reject(HelperFunctions.getErrorMessage(error))
      )
  }

  updateSyncData(medicine: ImportAdminMedicineModel) {
    return axios({
      url: `ImportData/updateSyncData/`,
      method: 'put',
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      },
      data: JSON.stringify(medicine)
    })
      .then(res => res.data.data)
      .catch(error =>
        Promise.reject(HelperFunctions.getErrorMessage(error))
      )
  }

  importRawData() {
    return axios({
      url: `importData/importRawData/`,
      method: 'get'
    })
      .then(res => res.data.data)
      .catch(error =>
        Promise.reject(HelperFunctions.getErrorMessage(error))
      )
  }

  syncData() {
    return axios({
      url: `SyncData/syncData/`,
      method: 'get'
    })
      .then(res => res.data.data)
      .catch(error =>
        Promise.reject(HelperFunctions.getErrorMessage(error))
      )
  }

  updateData() {
    return axios({
      url: `SyncData/updateData/`,
      method: 'get'
    })
      .then(res => res.data.data)
      .catch(error =>
        Promise.reject(HelperFunctions.getErrorMessage(error))
      )
  }


  loadImportSyncData(file: FileModel) {
    return axios({
      url: `synchronization/loadImportSync/`,
      method: 'post',
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      },
      data: JSON.stringify(file)
    })
      .then(res => res.data.data)
      .catch(error =>
        Promise.reject(HelperFunctions.getErrorMessage(error))
      )
  }

  getSettingsAndAllSchedulers(from: number, numberOfRows: number, settings: SchedulerFilterSettingsModel) {
    return axios({
      url: `syncScheduler/getAll/${from}/${numberOfRows}`,
      method: 'post', headers: {
        "Content-Type": "application/json; charset=utf-8"
      },
      data: JSON.stringify(settings)
    })
      .then(res => res.data.data)
      .catch(error =>
        Promise.reject(HelperFunctions.getErrorMessage(error))
      )
  }

  // getAll() {
  //   return axios({
  //     url: `syncScheduler/getAll/`,
  //     method: 'get'
  //   })
  //     .then(res => res.data.data)
  //     .catch(error =>
  //       Promise.reject(HelperFunctions.getErrorMessage(error))
  //     )
  // }

  addSyncSettings(syncSettings: SyncSettingsModel) {
    return axios({
      url: `syncScheduler/addSettings/`,
      method: 'post',
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      },
      data: JSON.stringify(syncSettings)
    })
      .then(res => res.data.data)
      .catch(error =>
        Promise.reject(HelperFunctions.getErrorMessage(error))
      )
  }

  editSyncSettings(syncSettings: SyncSettingsModel) {
    return axios({
      url: `syncScheduler/updateSettings/`,
      method: 'put',
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      },
      data: JSON.stringify(syncSettings)
    })
      .then(res => res.data.data)
      .catch(error =>
        Promise.reject(HelperFunctions.getErrorMessage(error))
      )
  }

  getSchedulerReport(id: number) {
    return axios({
      url: `syncScheduler/getReport/${id}`,
      method: 'get'
    })
      .then(res => res.data.data)
      .catch(error =>
        Promise.reject(HelperFunctions.getErrorMessage(error))
      )
  }

}

export default DataSyncService;


